export * from './FixedSlider';